module.exports = __webpack_public_path__ + "static/media/Main_main3.41e99862.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Main/assets/Main_main3.jpeg
// module id = 547
// module chunks = 0